module.exports = __webpack_public_path__ + "img/empty.8c3d2a79.svg";